// import {
//   Flex,
//   Text,
//   useColorModeValue,
// } from "@chakra-ui/react";
// import React, { useMemo, useEffect, useState } from "react";
// import { Bar } from 'react-chartjs-2';
// import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
// import Card from "components/card/Card";
// import { useTranslation } from "react-i18next";
// import fetchWithToken from "views/auth/signIn/axiosInstance";

// // Register Chart.js components
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// export default function ComplexTable({ title = "Branches", tableData: propTableData, dataKey = "ORDERS", labelKey = "Orders", barColor = "blue" }) {
//   const { t } = useTranslation();
//   // Use prop data if provided, else fallback to default demo data
//   const defaultData = [
//     { BRANCH: "New York", TRANSACTIONS: 120, ORDERS: 45, STATUS: true },
//     { BRANCH: "Los Angeles", TRANSACTIONS: 80, ORDERS: 0, STATUS: false },
//     { BRANCH: "Chicago", TRANSACTIONS: 100, ORDERS: 50, STATUS: true },
//     { BRANCH: "Houston", TRANSACTIONS: 90, ORDERS: 40, STATUS: true },
//     { BRANCH: "Phoenix", TRANSACTIONS: 0, ORDERS: 0, STATUS: false },
//   ];
//   const tableData = propTableData || defaultData;
//   const totalBranches = tableData.length;

//   const chartData = useMemo(() => {
//     return {
//       labels: tableData.map(branch => branch.BRANCH || branch.name),
//       datasets: [
//         {
//           label: t(labelKey),
//           data: tableData.map(branch => branch[dataKey]),
//           backgroundColor: barColor,
//         }
//       ]
//     };
//   }, [tableData, dataKey, labelKey, barColor, t]);

//   const textColor = useColorModeValue("secondaryGray.900", "white");
//   return (
//     <Card
//       shadow="xl"
//       direction='column'
//       w='100%'
//       px='0px'
//       overflowX={{ sm: "scroll", lg: "hidden" }}
//       maxW='600px'
//     >
//       <Flex px='25px' justify='space-between' mb='10px' align='center'>
//         <Text
//           color={textColor}
//           fontSize='24px'
//           fontWeight='bold'
//           lineHeight='100%'>
//           {title} ({totalBranches})
//         </Text>
//       </Flex>
//       <Bar data={chartData}  />
//     </Card>
//   );
// }
import React, { useMemo } from "react";
import Chart from "react-apexcharts";
import {
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import { useTranslation } from "react-i18next";

export default function ComplexTable({
  title = "Branches",
  tableData: propTableData,
  dataKey = "ORDERS",
  labelKey = "Orders",
  barColor = "#3c31ceff", // blue.500
}) {
  const { t } = useTranslation();

  // fallback demo data
  const defaultData = [
    { BRANCH: "New York", TRANSACTIONS: 120, ORDERS: 45, STATUS: true },
    { BRANCH: "Los Angeles", TRANSACTIONS: 80, ORDERS: 0, STATUS: false },
    { BRANCH: "Chicago", TRANSACTIONS: 100, ORDERS: 50, STATUS: true },
    { BRANCH: "Houston", TRANSACTIONS: 90, ORDERS: 40, STATUS: true },
    { BRANCH: "Phoenix", TRANSACTIONS: 0, ORDERS: 0, STATUS: false },
  ];
  const tableData = propTableData || defaultData;
  const totalBranches = tableData.length;


const chartData = useMemo(() => {
  const maxLabelLength = 15; // Maximum visible chars on x-axis

  // Store both full and truncated names
  const categories = tableData.map((b) => {
    const fullName = b.BRANCH || b.name || "";
    const shortName =
      fullName.length > maxLabelLength
        ? `${fullName.substring(0, maxLabelLength)}...`
        : fullName;
    return { fullName, shortName };
  });

  return {
    options: {
      chart: {
        type: "bar",
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          borderRadius: 6,
          horizontal: false,
          columnWidth: "50%",
        },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: categories.map((c) => c.shortName),
        labels: {
          style: { colors: "#3c31ce" },
        },
      },
      yaxis: {
        labels: { style: { colors: "#3c31ce" } },
      },
      title: {
        text: "",
      },
      colors: [barColor],
      tooltip: {
        // Use full name in the tooltip title
        x: {
          formatter: function (val, opts) {
            const { dataPointIndex } = opts;
            return categories[dataPointIndex]?.fullName || val;
          },
        },
        y: {
          formatter: (val) => val,
        },
      },
    },
    series: [
      {
        name: t(labelKey),
        data: tableData.map((b) => b[dataKey] || 0),
      },
    ],
  };
}, [tableData, dataKey, labelKey, barColor, t]);



  const textColor = useColorModeValue("secondaryGray.900", "white");

  return (
    <Card
      shadow="xl"
      direction="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
      maxW="600px"
    >
      <Flex px="25px" justify="space-between" mb="10px" align="center">
        <Text
          color={textColor}
          fontSize="24px"
          fontWeight="bold"
          lineHeight="100%"
        >
          {title} ({totalBranches})
        </Text>
      </Flex>

      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={300}
      />
    </Card>
  );
}
